/** @jsxImportSource @emotion/react */
import colors from '@sportninja/common/constants/appColors'

interface QuestionTypeIconProps {
  size?: number
  color?: string
  className?: string
}

/**
 * TextAreaIcon component - Icon for text area question type
 * @param size - Icon size in pixels (default: 24)
 * @param color - Icon color (default: colors.NEUTRAL_50)
 * @param className - Additional CSS class name
 */
const TextAreaIcon = ({
  size = 24,
  color = colors.NEUTRAL_50,
  className,
}: QuestionTypeIconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 25'
      fill='none'
      className={className}
    >
      <path
        d='M20 11.5H4C3.45 11.5 3 11.95 3 12.5C3 13.05 3.45 13.5 4 13.5H20C20.55 13.5 21 13.05 21 12.5C21 11.95 20.55 11.5 20 11.5ZM4 18.5H14C14.55 18.5 15 18.05 15 17.5C15 16.95 14.55 16.5 14 16.5H4C3.45 16.5 3 16.95 3 17.5C3 18.05 3.45 18.5 4 18.5ZM20 6.5H4C3.45 6.5 3 6.95 3 7.5V7.51C3 8.06 3.45 8.51 4 8.51H20C20.55 8.51 21 8.06 21 7.51V7.5C21 6.95 20.55 6.5 20 6.5Z'
        fill={color}
      />
    </svg>
  )
}

export default TextAreaIcon
